import { PRESET_LABELS } from '../utils/constants';
import { useDateRange } from '../contexts/DateRangeContext';

export default function DateRangeFilter() {
  const { startDate, endDate, selectedPreset, setStartDate, setEndDate, applyPreset } = useDateRange();

  return (
    <div className="date-filter compact-date-filter">
      <label className="range-preset-label">
        <span>Date Range</span>
        <select value={selectedPreset} onChange={(event) => applyPreset(event.target.value)}>
          <option value="Custom Range" disabled>Custom Range</option>
          {PRESET_LABELS.map((label) => <option key={label} value={label}>{label}</option>)}
        </select>
      </label>
      <div className="date-inputs">
        <label>
          <span>Start Date</span>
          <input type="date" value={startDate} onChange={(event) => setStartDate(event.target.value)} />
        </label>
        <label>
          <span>End Date</span>
          <input type="date" value={endDate} onChange={(event) => setEndDate(event.target.value)} />
        </label>
      </div>
    </div>
  );
}
